var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIiconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00033 8.00065C8.36699 8.00065 8.68088 7.8701 8.94199 7.60898C9.2031 7.34787 9.33366 7.03398 9.33366 6.66732C9.33366 6.30065 9.2031 5.98676 8.94199 5.72565C8.68088 5.46454 8.36699 5.33398 8.00033 5.33398C7.63366 5.33398 7.31977 5.46454 7.05866 5.72565C6.79755 5.98676 6.66699 6.30065 6.66699 6.66732C6.66699 7.03398 6.79755 7.34787 7.05866 7.60898C7.31977 7.8701 7.63366 8.00065 8.00033 8.00065ZM8.00033 14.6673C6.21144 13.1451 4.87533 11.7312 3.99199 10.4257C3.10866 9.1201 2.66699 7.91176 2.66699 6.80065C2.66699 5.13398 3.2031 3.80621 4.27533 2.81732C5.34755 1.82843 6.58921 1.33398 8.00033 1.33398C9.41144 1.33398 10.6531 1.82843 11.7253 2.81732C12.7975 3.80621 13.3337 5.13398 13.3337 6.80065C13.3337 7.91176 12.892 9.1201 12.0087 10.4257C11.1253 11.7312 9.78921 13.1451 8.00033 14.6673Z",
    fill: "#0057FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIiconBlue);
export default __webpack_public_path__ + "static/media/locationIiconBlue.fee547d3bdf96b7edac1d76cfbaf94fc.svg";
export { ForwardRef as ReactComponent };